import { PlugIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

import bingLogo from './assets/bing-logo.svg'
import googleLogo from './assets/google-logo.svg'
import redditLogo from './assets/reddit-logo.svg'

type ProviderIconSize = 'sm' | 'md' | 'lg'

export interface ConnectorProviderIconProps {
  providerSlug: string
  size?: ProviderIconSize
  className?: string
}

const PROVIDER_LOGO_MAP: Record<string, string> = {
  google: googleLogo,
  bing: bingLogo,
  reddit: redditLogo,
}

const SIZE_CLASSES: Record<ProviderIconSize, string> = {
  sm: 'size-8',
  md: 'size-10',
  lg: 'size-12',
}

const ICON_SIZE_CLASSES: Record<ProviderIconSize, string> = {
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-6',
}

/**
 * Displays a provider brand logo or a fallback plug icon for unknown providers.
 */
export const ConnectorProviderIcon: React.FC<ConnectorProviderIconProps> = ({
  providerSlug,
  size = 'md',
  className,
}: ConnectorProviderIconProps): ReactNode => {
  const logo = PROVIDER_LOGO_MAP[providerSlug]

  return (
    <div
      className={cn(
        'connector-provider-icon flex items-center justify-center rounded-lg border bg-muted',
        SIZE_CLASSES[size],
        className
      )}
    >
      {logo ? (
        <img src={logo} alt={providerSlug} className={ICON_SIZE_CLASSES[size]} />
      ) : (
        <PlugIcon className={cn('text-muted-foreground', ICON_SIZE_CLASSES[size])} />
      )}
    </div>
  )
}

ConnectorProviderIcon.displayName = 'ConnectorProviderIcon'
